export const REPLACE_ENTITLEMENT_PROJECTION = "REPLACE_ENTITLEMENT_PROJECTION";

export const initialEntitlementProjectionState = {
  status: "idle",
  projection: null,
  error: null,
  cause: null,
};

export const replaceEntitlementProjection = (payload) => ({
  type: REPLACE_ENTITLEMENT_PROJECTION,
  payload: payload || initialEntitlementProjectionState,
});

export default function entitlementReducer(
  state = initialEntitlementProjectionState,
  action
) {
  if (action.type === REPLACE_ENTITLEMENT_PROJECTION) return action.payload;
  return state;
}
